import { Map } from 'immutable';
import { connect } from '../../../../../react-redux';
import { closeModal } from '../../../../../actions/modal';
import { AddContentModal as AddContentModalPresenter } from './presenter';
import { ADD_CONTENT_MODAL, OPEN_ADD_CONTENT_MODAL_DATA } from '@instructure/quiz-common';
var mapStateToProps = function mapStateToProps(state) {
  var _state$getIn$toJS = state.getIn(['modal', OPEN_ADD_CONTENT_MODAL_DATA], Map()).toJS(),
    allowStimulusCreation = _state$getIn$toJS.allowStimulusCreation,
    parentEntryId = _state$getIn$toJS.parentEntryId,
    position = _state$getIn$toJS.position,
    quizId = _state$getIn$toJS.quizId,
    stimulusId = _state$getIn$toJS.stimulusId;
  var modalOpen = state.getIn(['modal', 'isOpen']) === ADD_CONTENT_MODAL;
  return {
    allowStimulusCreation: allowStimulusCreation,
    modalOpen: modalOpen,
    parentEntryId: parentEntryId,
    position: position,
    quizId: quizId,
    stimulusId: stimulusId
  };
};
var mapDispatchToProps = {
  closeModal: closeModal
};
export var AddContentModal = connect(mapStateToProps, mapDispatchToProps)(AddContentModalPresenter);
export default AddContentModal;